"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AllegroTransformSchematicGenerator = void 0;
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const TransformProject_1 = require("../../../../Shared/HierarchicalTransformer/TransformObjects/TransformProject");
const TransformSchematic_1 = require("../../../../Shared/HierarchicalTransformer/TransformObjects/TransformSchematic");
const TransformSchematicLayerSet_1 = require("../../../../Shared/HierarchicalTransformer/TransformObjects/TransformSchematicLayerSet");
const NetCombobulator_1 = require("../../../../NetCombobulation/NetCombobulator");
const fonts_1 = require("../../../../Fonts/fonts");
const allegroLayers_1 = require("../../../allegroLayers");
const AllegroNetNamingStrategy_1 = require("../AllegroNetNamingStrategy");
class AllegroTransformSchematicGenerator {
    constructor() {
        this.runsFor = [TransformProject_1.TransformProject];
    }
    *generate(project, rootContext) {
        const namingStrategy = new AllegroNetNamingStrategy_1.AllegroNetNamingStrategy();
        for (let sheetIndex = 0; sheetIndex < rootContext.sheetPages.length; sheetIndex++) {
            const loaded = rootContext.sheetPages[sheetIndex];
            const hierarchy = buildHierarchy(loaded);
            const instance = buildInstance(hierarchy);
            hierarchy.parents = [];
            hierarchy.children = [];
            const combobulator = new NetCombobulator_1.NetCombobulator(instance.netRefCtx, namingStrategy, instance, { pointRoundingPrecision: 0.1 });
            const schematic = new TransformSchematic_1.TransformSchematic(project, {
                designId: hierarchy.slug,
                designName: loaded.sheetName.length > 0 ? loaded.sheetName : loaded.pageFileName,
                sheetIndex,
                sourceFile: loaded.sourcePath,
                font: { default: fonts_1.Font.Newstroke },
                instance,
            }, combobulator, project.context);
            yield schematic;
            yield buildLayerSet(schematic);
        }
    }
}
exports.AllegroTransformSchematicGenerator = AllegroTransformSchematicGenerator;
function buildHierarchy(loaded) {
    return {
        name: loaded.sheetName.length > 0 ? loaded.sheetName : loaded.pageFileName,
        sourceFile: loaded.sourcePath,
        schematicIndex: 0,
        hierarchyIndex: 0,
        children: [],
        parents: [],
        schematic: loaded,
        loaded,
        slug: hierarchySlug(loaded),
    };
}
function buildInstance(hierarchy) {
    return {
        hierarchyEntry: hierarchy,
        path: [],
        children: [],
        pathUniqueId: hierarchy.slug,
        numInstances: 1,
        totalSheetInstances: 1,
        instanceIndex: 0,
        sheetSymbol: undefined,
        netRefCtx: new sigma_engine_shared_1.NetRefCtx(),
    };
}
function hierarchySlug(loaded) {
    if (loaded.sheetName.length > 0) {
        return `${loaded.sheetName}__${loaded.sheetId}`;
    }
    return loaded.pageFileName;
}
function buildLayerSet(schematic) {
    return new TransformSchematicLayerSet_1.TransformSchematicLayerSet(schematic, {
        type: 'layerSet',
        id: allegroLayers_1.ALLEGRO_SCH_LAYERSET,
        layerSetType: 'schematic',
        layers: allegroLayers_1.AllegroSchLayers.map((layer) => ({ ...layer, defaultVisible: true })),
    });
}
//# sourceMappingURL=AllegroTransformSchematicGenerator.js.map